// extracted by mini-css-extract-plugin
module.exports = {"thenAction":"Rule_thenAction__1ouaK"};